console.log('Slicks are working');
import $ from 'jquery'
import 'slick-carousel'

$(function () {
  console.log('jQuery is working');
});
const prevArrow = `<button type="button" class="slick-prev"><img src="/svg/chevron-left-circle-solid.svg"></button>`;
const nextArrow = '<button type="button" class="slick-next"><img src="/svg/chevron-right-circle-solid.svg"></button>';

$('.home-section-excursions__excursions').slick({
    arrows : false,
    dots : true,
    // normal options...
    infinite : true,
    slidesToShow: 3,
    slidesToScroll: 3,


    // the magic
    responsive: [{

        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true
        }

      }, {

        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }

      },
    ]
  })

$('.private-excursions-index__excursions').slick({
    arrows : false,
    dots : true,
    // normal options...
    infinite : true,
    slidesToShow: 4,


    // the magic
    responsive: [{

        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          infinite: true
        }

      }, {

        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true
        }

      },
    ]
  })

$('.card-excursion__carousel').slick({
    autoplay: true,
    autoplaySpeed : 3000,
    speed : 1000, //transition speed
    fade : true,
    arrows : false,
    // normal options...
    infinite : true,
    slidesToShow: 1,
  })


$('.home-section-boats__carousel').slick({
    autoplay: false,
    autoplaySpeed : 0,
    speed : 2000, //transition speed
    arrows : true,
    prevArrow,
    nextArrow,
    infinite : true,
    slidesToShow: 1,

  })

